// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1116":"625a077d5f388d91","8743":"bf68ebf164f8ec48"}[chunkId] + ".js";
};